import {Box} from '@mui/material'
import {useState} from 'react'
import {KonvaImageDetectionsFullscreen} from 'src/common/components/konva-image-detections-fullscreen/KonvaImageDetectionsFullscreen'
import LoadMoreButton from 'src/components/Button/LoadMoreButton'
import RowHover from 'src/components/RowHover/RowHover'
import Table from 'src/components/table/Table'
import TableData from 'src/components/table/components/tableData/TableData'
import {useCompany} from 'src/contexts/CompanyContext'
import MenuMoreInformations from 'src/pages/lpr/components/LprMoreInformations'
import {lprEventRow} from 'src/pages/lpr/components/lpr-grid-table/LprGridTableFunctions'
import {Lpr, LprFilterType} from 'src/services/api/endpoints/LprEndpoint'
import {AddPlateToListModal} from '../lpr-black-list/AddPlateToListModal'
import {lprGridTableStyles} from './LprGridTableBase'

type LprGridTableProps = {
  loadingInformation: boolean
  loadingMore: boolean
  lprEvents: Lpr[]
  filter: LprFilterType
  setFilter: (filter: LprFilterType) => void
  fetchNextPage: () => void
  canLoadMore: boolean
}

function LprGridTable({loadingInformation, lprEvents, setFilter, filter, fetchNextPage, loadingMore, canLoadMore}: LprGridTableProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenPlateList, setIsOpenPlateList] = useState(false)
  const [plateLpr, setPlateLpr] = useState('')
  const [imageKey, setImageKey] = useState<{src: string; from: string}>()
  const [selectedPlateCompanyId, setSelectedPlateCompanyId] = useState<number>(0)
  const {companies} = useCompany()

  const openImageModal = (key: string, src: string) => {
    setIsOpen(true)
    const img = {
      src: key,
      from: src.toLowerCase().includes('migrate') ? 'migrate' : 'old',
    }
    setImageKey(img)
  }
  const closeImageModal = () => {
    setIsOpen(false)
  }

  const columns = [
    {
      id: 'camera',
      name: 'Nome da câmera',
    },
    {
      id: 'company',
      name: 'Empresa',
    },
    {
      id: 'dateTime',
      name: 'Data/hora',
    },
    {
      id: 'plate',
      name: 'Placa',
    },
    {
      id: 'plateImage',
      name: 'Imagem da Placa',
    },
    {
      id: 'brand',
      name: 'Marca',
    },
    {
      id: 'model',
      name: 'Modelo',
    },
    {
      id: 'color',
      name: 'Cor',
    },
    {
      id: 'sentTo',
      name: 'Enviado para',
    },
    {
      id: 'contextMenu',
      name: '',
    },
  ]

  return (
    <Box padding={'20px'} sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', backgroundColor: 'white'}}>
      <Box sx={[lprGridTableStyles.gridItem]}>
        <AddPlateToListModal
          isOpenModal={isOpenPlateList}
          closeModal={() => setIsOpenPlateList(false)}
          plateLpr={plateLpr}
          companyId={selectedPlateCompanyId}
        />
        <Table columns={columns} isLoading={loadingInformation} skeletonRowsAmount={20}>
          {lprEventRow(lprEvents, companies).map((row) => (
            <RowHover id={`row-${row.id}`} cursorType='auto'>
              <TableData>{row.camera}</TableData>
              <TableData>{row.company}</TableData>
              <TableData>{row.dateTime}</TableData>
              <TableData>{row.plate}</TableData>
              <TableData>
                <Box sx={{display: 'flex', height: '41px', padding: '2px'}}>
                  <img
                    onClick={(e) => openImageModal(row.fullImageKey, e.currentTarget.src)}
                    src={`${process.env.REACT_APP_CROPPED_IMAGES_BASE_URL}/${row.croppedImageKey}`}
                    alt='Imagem não encontrada'
                  />
                </Box>
              </TableData>
              <TableData>{row.brand}</TableData>
              <TableData>{row.model}</TableData>
              <TableData>{row.color}</TableData>
              <TableData>{row.sentTo}</TableData>
              <TableData>
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <MenuMoreInformations
                    oneLpr={row.id}
                    onClick={(event) => {
                      if (event === 'add-to-list') {
                        setSelectedPlateCompanyId(row.self.camera.companyId)
                        setPlateLpr(row.plate.toString())
                        setIsOpenPlateList(true)
                      }
                      if (event === 'see-vehicle-transity') {
                        setFilter({...filter, plates: [row.plate.toString()]})
                      }
                    }}
                    cameraId={row.self.camera.id}
                  />
                </Box>
              </TableData>
            </RowHover>
          ))}
        </Table>
        {isOpen && (
          <KonvaImageDetectionsFullscreen
            open={Boolean(imageKey?.src)}
            src={
              imageKey?.from === 'migrate'
                ? `https://migrate-event-images-prd.appbrain.com.br/${imageKey.src}`
                : `https://event-images-prd.appbrain.com.br/${imageKey?.src}`
            }
            detections={[]}
            onClose={closeImageModal}
          />
        )}

        {!loadingInformation && lprEvents.length === 0 ? (
          <Box sx={lprGridTableStyles.noRegisters}>Nenhum registro encontrado</Box>
        ) : (
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '6px'}}>
            <LoadMoreButton onClick={() => fetchNextPage()} isLoading={loadingMore} disabled={!canLoadMore} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default LprGridTable
